// extracted by mini-css-extract-plugin
module.exports = {"table":"ActivationList_table_2dth5","addButton":"ActivationList_addButton_5t-rR"};